export const THIRD_PARTY_TYPE = "THIRD_PARTY";
export const RECIPIENT_TYPE = "RECIPIENT";
export const OTHER_BUYER_TYPE = "OTHER_BUYER";
export const LIMIT_OPTIONS = [{ title: 10 }, { title: 20 }, { title: 50 }];
export const THIRD_PARTY_CARRIERS = ["DHL EXPRESS", "FEDEX", "UPS"];
export const OTHER_BUYER_CARRIERS = ["DHL EXPRESS"];
export const VOEC_CARRIERS = ["UPS", "DHL", "FEDEX"];
export const VOEC_ELIGIBLE_PRODUCTS = ["PARCEL CONNECT"];
